export default __webpack_public_path__ + "static/media/logo-cinco-blue.f562efb1.svg";